import { Injectable } from "@angular/core";
import { createEffect } from "@ngrx/effects";
import { defer, of } from "rxjs";
import { filter, map } from "rxjs/operators";

import { STATE_TRANSFER_ACTION_TYPE } from "./state-transfer";
import { StateTransferService } from "./state-transfer.service";

@Injectable()
export class StateTransferEffect {
	set$ = createEffect(() =>
		defer(() =>
			of(this.stateTransferService.getState()).pipe(
				filter((x) => !!x),
				map((payload) => ({ type: STATE_TRANSFER_ACTION_TYPE.set, payload }))
			)
		)
	);

	constructor(private stateTransferService: StateTransferService) {}
}
